module.exports = __webpack_public_path__ + "seo-twitter.b174cd7.jpg";